<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="wishlists" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="wishlistId"
  selectionMode="single" [(selection)]="wishlist" (onRowSelect)="onRowSelect($event)"
  [loading]="loading" [paginator]="true" [rows]="50" [rowsPerPageOptions]="[25,50,100,200]"
  showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}"
  [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta"
  styleClass="p-datatable-striped" [resizableColumns]="true" [autoLayout]="true" [responsive]="true"
  class="edit_filterList">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left; margin: 6px;">Activity Wish Lists</h1>
      <span>
        <button pButton pRipple class="p-button-text"
          style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
      </span>
    </div>
  </ng-template>

  <ng-template pTemplate="header">
    <tr>
      <th pSortableColumn="guestLastName">Guest Name <p-sortIcon field="guestLastName"></p-sortIcon></th>
      <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
      <th pSortableColumn="propertyName">Property <p-sortIcon field="propertyName"></p-sortIcon></th>
      <th pSortableColumn="checkIn">Check-in <p-sortIcon field="checkIn"></p-sortIcon></th>
      <th pSortableColumn="checkOut">Check-out <p-sortIcon field="checkOut"></p-sortIcon></th>
      <th pSortableColumn="addressIsland">Island <p-sortIcon field="addressIsland"></p-sortIcon></th>
      <th pSortableColumn="createDate">Created <p-sortIcon field="createDate"></p-sortIcon></th>
      <th></th>
    </tr>
    <tr>
      <th><input pInputText type="text" style="width:100%;min-width:80px;" (input)="pt.filter($event.target.value, 'guestLastName', 'contains')"></th>
      <th>
        <p-dropdown [options]="statuses" optionLabel="name" optionValue="value" placeholder="All"
          [showClear]="true" styleClass="w-100"
          (onChange)="pt.filter($event.value, 'status', 'equals')"></p-dropdown>
      </th>
      <th><input pInputText type="text" style="width:100%;min-width:80px;" (input)="pt.filter($event.target.value, 'propertyName', 'contains')"></th>
      <th></th>
      <th></th>
      <th><input pInputText type="text" style="width:100%;min-width:60px;" (input)="pt.filter($event.target.value, 'addressIsland', 'contains')"></th>
      <th></th>
      <th></th>
    </tr>
  </ng-template>

  <ng-template pTemplate="body" let-row>
    <tr [pSelectableRow]="row">
      <td>{{row.guestFirstName}} {{row.guestLastName}}</td>
      <td>
        <p-tag [value]="row.status" [severity]="getStatusSeverity(row.status)"></p-tag>
      </td>
      <td>{{row.propertyName}}</td>
      <td>{{row.checkIn | date:'MM/dd/yyyy'}}</td>
      <td>{{row.checkOut | date:'MM/dd/yyyy'}}</td>
      <td>{{row.addressIsland}}</td>
      <td>{{row.createDate | date:'MM/dd/yyyy'}}</td>
      <td>
        <a (click)="onRowDelete(row); $event.stopPropagation()">
          <mat-icon style="color:red; font-size:110%; cursor:pointer;">delete</mat-icon>
        </a>
      </td>
    </tr>
  </ng-template>

</p-table>
